import Q22 from './Q22';

export default Q22;
